import useLiveMode from "ui/scenes/live/shared/useLiveMode";

const LiveModeRedirector = () => {
  useLiveMode();
  return null;
};

export default LiveModeRedirector;
